<template>
  <div class="container-fluid">
    <Toolbar class="m-2">
      <template #start>
        <h2>{{ $t('nav.stakeholder') }}</h2>
      </template>

      <template #end>
        <Button
          :label="$t('stakeholderpage.create')"
          icon="pi pi-plus"
          class=" p-button-success mr-2 p-button-outlined p-button-rounded"
          @click="toStakeholderForm()"
        />
      </template>
    </Toolbar>

    <Paginator
      v-model:first="actualPage"
      v-model:rows="pageSize"
      :total-records="totalItemsCount"
      @page="onPageChange($event)"
    />

    <DataTable
      v-model:sortField="sortField"
      v-model:sortOrder="sortOrder"
      v-model:filters="filters"
      lazy
      row-hover
      striped-rows
      :value="stakeholders"
      responsive-layout="scroll"
      filter-display="row"
      class="p-datatable-sm"
      @sort="onSort($event)"
      @filter="onFilter($event)"
    >
      <Column :style="{maxWidth:'40px'}">
        <template #body="{data}">
          <Button
            icon="pi pi-pencil"
            class="p-button-rounded mx-1"
            :title="$t('action.crud.update')"
            @click="toStakeholderForm(data.stakeholderId)"
          />
        </template>
      </Column>
      <Column
        field="stakeholderId"
        :header="$t('entity.stakeholder.stakeholderId')"
        :sortable="true"
        :show-filter-menu="false"
      >
        <template #body="{data}">
          {{ data.stakeholderId }}
        </template>
        <template #filter="{filterModel,filterCallback}">
          <InputText
            v-model="filterModel.value"
            type="text"
            class="p-column-filter"
            @keydown.enter="filterCallback()"
          />
        </template>
      </Column>

      <Column
        field="name"
        :header="$t('entity.stakeholder.name')"
        :sortable="true"
        :show-filter-menu="false"
      >
        <template #body="{data}">
          {{ data.name }}
        </template>
        <template #filter="{filterModel,filterCallback}">
          <InputText
            v-model="filterModel.value"
            type="text"
            class="p-column-filter"
            @keydown.enter="filterCallback()"
          />
        </template>
      </Column>
      <Column
        :header="$t('stakeholderpage.locked')"
        class="col-1"
      >
        <template #body="{data}">
          <div class="p-checkbox p-component">
            <Checkbox
              v-model="data.locked"
              :binary="true"
              @click.prevent="data.locked ? openActivateDialog(data.stakeholderId) : openDeactivateDialog(data.stakeholderId)"
            />
          </div>
        </template>
      </Column>
    </DataTable>

    <Paginator
      v-model:first="actualPage"
      v-model:rows="pageSize"
      :total-records="totalItemsCount"
      @page="onPageChange($event)"
    />

    <Dialog
      v-model:visible="dialogActivate"
      :modal="true"
    >
      <template #header>
        <h3>{{ $t('stakeholderpage.dialog.activate.header') }}</h3>
      </template>

      <div class="confirmation-content">
        <span>{{ $t('stakeholderpage.dialog.activate.content') }}</span>
      </div>
      <template #footer>
        <Button
          :label="$t('stakeholderpage.dialog.abortButton')"
          icon="pi pi-times"
          class="p-button-rounded p-button-outlined"
          @click="abort"
        />
        <Button
          :label="$t('stakeholderpage.dialog.confirmButton')"
          icon="pi pi-check"
          class="p-button-rounded p-button-outlined"
          @click="activateStakeholder"
        />
      </template>
    </Dialog>

    <Dialog
      v-model:visible="dialogDeactivate"
      :modal="true"
    >
      <template #header>
        <h3>{{ $t('stakeholderpage.dialog.deactivate.header') }}</h3>
      </template>

      <div class="confirmation-content">
        <span>{{ $t('stakeholderpage.dialog.deactivate.content') }}</span>
      </div>
      <template #footer>
        <Button
          :label="$t('stakeholderpage.dialog.abortButton')"
          icon="pi pi-times"
          class="p-button-rounded p-button-outlined"
          @click="abort"
        />
        <Button
          :label="$t('stakeholderpage.dialog.confirmButton')"
          icon="pi pi-check"
          class="p-button-rounded p-button-outlined"
          @click="deactivateStakeholder"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>

import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Paginator from 'primevue/paginator';
import InputText from 'primevue/inputtext';
import Toolbar from 'primevue/toolbar';
import Button from 'primevue/button'
import Dialog from "primevue/dialog";
import {FilterMatchMode} from "primevue/api";
import Checkbox from 'primevue/checkbox';

export default {
  name: 'StakeholderTable',
  components: { Column, DataTable, Paginator, InputText, Toolbar, Button, Dialog, Checkbox },
  data() {
    return {
      stakeholders: [],
      page: 0,
      pageSize: 100,
      totalItemsCount: 0,
      sortField: 'stakeholderId',
      sortOrder: 1,
      filters: {
        'stakeholderId': { value: null, matchMode: FilterMatchMode.CONTAINS },
        'name': { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
      isLoading: false,
      dialogDeactivate: false,
      dialogActivate: false,
      selectedId: null,
      actualPage: 1,
    }
  },
  mounted() {
    this.refresh()
  },
  methods: {

    refresh() {
      this.getStakeHolders()
    },
    async getStakeHolders() {
      this.isLoading = true
      try {
        const {
          content,
          totalElements
        } = await this.$stakeHolderService.fetchStakeholdersPagingAndSorting(this.getRequestParams())
        this.stakeholders = content;
        this.totalItemsCount = totalElements;
      } catch (e) {
        const errors = e.response.data.map(error => this.$t(error)).join(', ')
        this.$emitter.emit('toast', { severity: 'error', message: errors })
      } finally {
        this.isLoading = false
      }
    },
    onPageChange(event) {
      this.page = event.page;
      this.getStakeHolders();
      this.actualPage = event.page * this.lineIdFilter.pageable.size;
    },
    onSort(event) {
      this.sortField = event.sortField;
      this.sortOrder = event.sortOrder;
      this.getStakeHolders()
    },
    onFilter(event) {
      this.filters = event.filters;
      this.getStakeHolders()
    },
    getRequestParams() {
      let params = {};
      params["sort"] = this.sortField + ',' + (this.sortOrder === 1 ? 'asc' : 'desc');
      if (this.page !== 0) {
        params["page"] = this.page;
      }
      if (this.pageSize) {
        params["size"] = this.pageSize;
      }
      if (this.filters.name.value) {
        params["name"] = this.filters.name.value;
      }
      if (this.filters.stakeholderId.value) {
        params["stakeholderId"] = this.filters.stakeholderId.value;
      }

      return params;
    },
    toStakeholderForm(stakeholderId) {
      if (stakeholderId) {
        this.$router.push({ name: 'stakeholderUpdate', params: { id: stakeholderId } })
      } else {
        this.$router.push({ name: 'stakeholderAdd' })
      }
    },
    openActivateDialog(id) {
      this.selectedId = id
      this.dialogActivate = true
    },
    openDeactivateDialog(id) {
      this.selectedId = id
      this.dialogDeactivate = true
    },
    abort() {
      this.dialogActivate = false
      this.dialogDeactivate = false
      this.refresh()
    },
    async activateStakeholder() {
      this.dialogActivate = false;
      const activate = await this.$stakeHolderService.unlockStakeholder(this.selectedId)
      if (activate) {
        this.$emitter.emit('toast', { severity: 'success', message: 'stakeholderpage.toast.activate.success' })
      } else {
        this.$emitter.emit('toast', { severity: 'error', message: 'stakeholderpage.toast.activate.error' })
      }
      this.refresh()
    },
    async deactivateStakeholder() {
      this.dialogDeactivate = false;
      const deactivate = await this.$stakeHolderService.lockStakeholder(this.selectedId)
      if (deactivate) {
        this.$emitter.emit('toast', { severity: 'success', message: 'stakeholderpage.toast.deactivate.success' })
      } else {
        this.$emitter.emit('toast', { severity: 'error', message: 'stakeholderpage.toast.deactivate.error' })
      }
      this.refresh()
    },
  }
}

</script>

<style lang="scss" scoped>
.pi-check {
  color: $green;
}

.pi-times {
  color: $red;
}

::v-deep(.p-datatable .p-datatable-tbody td) {
  padding: .25rem 1rem;
}
</style>
